import React, { useEffect, useState, memo } from 'react';
const setCookie = (name: string, value: string, days: number) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = '; expires=' + date.toUTCString();
  document.cookie = name + '=' + value + expires + '; path=/';
};
const getCookie = (name: string) => {
  if (typeof document === 'undefined') return null;
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};
export const CountdownBadge = memo(function CountdownBadge() {
  const [copiesLeft, setCopiesLeft] = useState(() => {
    if (typeof document !== 'undefined') {
      const storedCount = getCookie('cortisolCopiesLeft');
      // Start at 35 as requested
      return storedCount ? parseInt(storedCount) : 35;
    }
    return 35;
  });
  useEffect(() => {
    if (!getCookie('cortisolCopiesLeft')) {
      setCookie('cortisolCopiesLeft', '35', 30);
    }
    let intervalId: NodeJS.Timeout;
    const timeoutId = setTimeout(() => {
      intervalId = setInterval(() => {
        setCopiesLeft(prevCount => {
          // Decrease randomly but don't go below 3 to maintain urgency without looking fake
          const decreaseBy = Math.random() > 0.7 ? 1 : 0;
          if (decreaseBy === 0) return prevCount;
          const newCount = prevCount > 3 ? prevCount - 1 : 3;
          setCookie('cortisolCopiesLeft', newCount.toString(), 30);
          return newCount;
        });
      }, 8000); // Check every 8 seconds
    }, 3000);
    return () => {
      clearTimeout(timeoutId);
      if (intervalId) clearInterval(intervalId);
    };
  }, []);
  return <div className="inline-flex items-center bg-red-100 border border-red-200 text-red-700 font-bold px-4 py-2 rounded-full shadow-sm animate-pulse text-sm md:text-base" data-id="element-14">
      <span className="relative flex h-3 w-3 mr-2" data-id="element-15">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-16"></span>
        <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500" data-id="element-17"></span>
      </span>
      ¡Atención! Solo {copiesLeft} copias disponibles a este precio
    </div>;
});